import React from 'react';

import NamedOutcome from '../outcomes/NamedOutcome.jsx';
import SlotName from './SlotName.jsx';

export default class NamedOutcomeSlot extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        sportId: React.PropTypes.number.isRequired,
        match: React.PropTypes.object,
        slot: React.PropTypes.object.isRequired,
        outcomes: React.PropTypes.array.isRequired,
        gridLocalization: React.PropTypes.object.isRequired
    };

    static renderOutcome(outcome, props) {
        return (<NamedOutcome key={outcome.get('id')} outcome={outcome} {...props}/>);
    }

    shouldComponentUpdate(nextProps) {
        return this.props.gridLocalization !== nextProps.gridLocalization ||
            this.props.slot !== nextProps.slot ||
            this.props.outcomes !== nextProps.outcomes;
    }

    render() {
        const {section, sportId, match, slot, outcomes, gridLocalization} = this.props;

        const slotNameProps = {
            sportId,
            match,
            slot,
            outcome: outcomes[0],
            gridLocalization
        };

        const props = {
            section,
            sportId,
            match,
            gridLocalization
        };

        return (
            <div className="table detailed named-outcome">
                <div className="row inner">
                    <div className="cell main">
                        <SlotName {...slotNameProps}/>
                    </div>

                    <div className="cell rate ss">
                        <div className="rates">
                            {outcomes.map((o) => NamedOutcomeSlot.renderOutcome(o, props))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/slots/NamedOutcomeSlot.jsx